import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./profile.css";
import PatsForm from "../home/patsForm";

//Tabs
import ProfileReceived from "./tabReceivedPosts";
import ProfileSent from "./tabSentPosts";
import ProfileAll from "./tabAllPosts";

//React alert
import { useAlert } from "react-alert";
//React tabs
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
//#region Images

import profile from "../../assets/images/profile.jpg";
import pgiven from "../../assets/images/profile-given.png";
import prec from "../../assets/images/profile-received.png";
import ptot from "../../assets/images/profile-total.png";

//#endregion Images

function Profile() {
  const alert = useAlert();
  const [earnedPats, setEarnedPats] = useState(0);
  const [totMonthlyRecPats, settotMonthlyRecPats] = useState(0);
  const [totMonthlySentPats, settotMonthlySentPats] = useState(0);
  const [patsRedeemed, setPatsRedeemed] = useState(0);
  let { id } = useParams();
  //console.log("idddddddddddd", id);
  //Hook to rerender when new post is added
  const [refresh, setRefresh] = useState(0);
  const [badgeCount, setBadgeCount] = useState(0);
  const [userBadges, setUserBadges] = useState([]);
  const [badgesCv, setBadges] = useState([]);

  const [userName, setUserName] = useState("");
  const [userTeam, setUserTeam] = useState("");
  const Name = userName;
  const Team = userTeam;
  const [profileImg, setProfileImg] = useState("");
  //change value if monthly user pats change

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/posts/hashtag")
      .then((response) => response.json())
      .then((data) => {
        setBadges(data);
      });
  }, [id]);
  //#region Feed, Lazy load
  useEffect(() => {
    //Get Monthly pats and Earned pats on load.
    fetch(process.env.REACT_APP_API_URL + "api/user/profile/" + id)
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          // console.log("no", data);
          if (!data.patsrec <= 0 || !data.patsrec == null) {
            settotMonthlyRecPats(data.patsrec);
          } else {
            settotMonthlyRecPats(0);
          }
          if (!data.patsredeemed <= 0 || !data.patsredeemed == null) {
            setPatsRedeemed(data.patsredeemed);
          } else {
            setPatsRedeemed(0);
          }
          if (!data.patssent <= 0 || !data.patssent == null) {
            settotMonthlySentPats(data.patssent);
          } else {
            settotMonthlySentPats(0);
          }
          setEarnedPats(data.user.earnedPats);
          setUserName(data.user.UserName);
          setProfileImg(data.user.UserImage);
          setUserTeam(data.user.UserTeam);
          setUserBadges(data.userBadges);
          setBadgeCount(data.userBadges.length);
        }
      });
  }, [refresh, id]);
  //#endregion

  function imageDisplay() {
    //follow likes comp
    const cnt = badgeCount - 3;
    if (badgeCount > 0) {
      if (badgeCount <= 3) {
        return (
          //React Fragment to avoid extra div
          <>
            {userBadges.map((badge, index) => (
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  "api/images/badges/" +
                  badge.BadgeImage
                }
              />
            ))}
          </>
        );
      } else {
        var profileBadges = [];
        for (var i = 0; i < badgeCount; i++) {
          if (i < 3) {
            profileBadges.push(userBadges[i]);
          } else {
            break;
          }
        }
        return (
          //React Fragment to avoid extra div using for
          <>
            {profileBadges.map((badge, index) => (
              <img
                src={
                  process.env.REACT_APP_API_URL +
                  "api/images/badges/" +
                  badge.BadgeImage
                }
              />
            ))}
            <div className="profile-pd-badges-others">
              <p>
                <b>+{cnt}</b>Others
              </p>
            </div>
          </>
        );
      }
    }
  }

  return (
    <section>
      <div className="profile-row">
        <div className="profile-data">
          {/*Page title[pt]*/}
          <div className="profile-tt-title-wrap">
            <div className="profile-pt-flex">
              <div className="profile-pt-img">
                <img
                  src={
                    process.env.REACT_APP_IMG_URL +
                    (profileImg ? profileImg : "no-img.png")
                  }
                />
              </div>
              <div className="profile-pt-text">
                <h1>{Name}</h1>
                <h3>{Team} Team</h3>
              </div>
            </div>
          </div>
          {/*Page title[pt]-----END*/}
          {/*Pats details[pd]*/}
          <div>
            <div className="profile-pd-wrap">
              <div className="profile-pd-pats-wrap">
                <h1>Pats</h1>
                <div className="profile-pd-card-flex">
                  <div className="profile-pd-card profile-pd-card-item">
                    <div classsName="profile-pd-ct-wrap">
                      <p>Total</p>
                      <h3>{totMonthlySentPats}</h3>
                      <h2>Pats Given</h2>
                      <img src={pgiven} />
                    </div>
                  </div>
                  <div className="profile-pd-card profile-pd-card-item1">
                    <div classsName="profile-pd-ct-wrap">
                      <p>Total</p>
                      <h3>{totMonthlyRecPats}</h3>
                      <h2>Pats Received</h2>
                      <img src={prec} />
                    </div>
                  </div>
                  <div className="profile-pd-card profile-pd-card-item2">
                    <div classsName="profile-pd-ct-wrap">
                      <p>Total</p>
                      <h3>{patsRedeemed}</h3>
                      <h2> Pats Redeemed </h2>
                      <img src={ptot} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile-pd-badges-wrap">
                <h1>Badges</h1>
                <div className="profile-pd-badges-flex">
                  <div className="profile-pd-card profile-pd-badges-item">
                    <div classsName="profile-pd-bt-wrap">
                      <h3>{badgeCount}</h3>
                      <h2> Earned</h2>
                      {imageDisplay()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Pats details[pd]-----END*/}
          {/*Tabs*/}
          <Tabs>
            <TabList>
              <Tab>All</Tab>
              <Tab>Received</Tab>
              <Tab>Sent</Tab>
            </TabList>

            {/*Tabs*/}
            {/*Pats Form[pf]*/}
            {/* <PatsForm refresh={refresh} setRefresh={setRefresh} /> */}
            {/*Pats Form[pf]-----END*/}
            {/*Pats Posts[pp]*/}
            <div className="profile-pp-wrap">
              <TabPanel>
                <ProfileAll id={id} />
              </TabPanel>
              <TabPanel>
                <ProfileReceived id={id} />
              </TabPanel>
              <TabPanel>
                <ProfileSent id={id} />
              </TabPanel>
            </div>
            {/*Pats Posts[pp]-----END*/}
          </Tabs>
        </div>
      </div>
    </section>
  );
}

export default Profile;
